"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _VerifiedUser = _interopRequireDefault(require("@material-ui/icons/VerifiedUser"));

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    invalid: {
      color: theme.palette.error[500]
    },
    valid: {
      color: theme.palette.valid[500]
    }
  };
});

var UserStatus = function UserStatus(_ref) {
  var invitedAt = _ref.invitedAt,
      activatedAt = _ref.activatedAt,
      blocked = _ref.blocked,
      activeLabel = _ref.activeLabel,
      blockedLabel = _ref.blockedLabel,
      notActiveLabel = _ref.notActiveLabel,
      notInvitedLabel = _ref.notInvitedLabel;
  var classes = useStyles();
  var labelMap = {
    BLOCKED: blockedLabel,
    ACTIVE: activeLabel,
    INVITED: notActiveLabel,
    DEFAULT: notInvitedLabel
  };
  var iconMap = {
    BLOCKED: _Block["default"],
    ACTIVE: _VerifiedUser["default"],
    INVITED: _Error["default"]
  };
  var style = {
    BLOCKED: 'invalid',
    INVITED: 'invalid',
    ACTIVE: 'valid'
  };
  var status = blocked ? 'BLOCKED' : activatedAt ? 'ACTIVE' : invitedAt ? 'INVITED' : 'DEFAULT';

  if (status === 'DEFAULT') {
    return '';
  }

  var Icon = iconMap[status];
  return /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: labelMap[status]
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    classes: {
      root: classes[style[status]]
    },
    "aria-label": "settings"
  }, !!Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    classes: classes.icon
  })));
};

UserStatus.propTypes = {
  activatedAt: _propTypes["default"].string,
  invitedAt: _propTypes["default"].string,
  activeLabel: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  notActiveLabel: _propTypes["default"].string,
  notInvitedeLabel: _propTypes["default"].string,
  blockedLabel: _propTypes["default"].string,
  blocked: _propTypes["default"].bool
};
UserStatus.defaultProps = {
  activeLabel: 'Actief als gebruiker',
  blockedLabel: 'Geblokkeerd',
  notActiveLabel: 'Nog niet geactiveerd',
  notInvitedLabel: 'Nog niet uitgenodigd'
};
var _default = UserStatus;
exports["default"] = _default;